module.exports = __webpack_public_path__ + "img/pic12.69cded01.png";